/* jshint bitwise:true, browser:true */
/* global jQuery:false */
;(function viewport (W, D, $) {
  /**
   * misc global scripts
   * @requires jQuery
   */

  'use strict'

  if (typeof W.sg === 'undefined') {
    W.sg = {}
  }

  W.sg.throttle = function throttle (func, wait, options) {
    // =============================================================================
    // http://underscorejs.org/docs/underscore.html#section-82
    // Returns a function, that, when invoked, will only be triggered at most once
    // during a given window of time. Normally, the throttled function will run as
    // much as it can, without ever going more than once per wait duration; but if
    // you’d like to disable the execution on the leading edge, pass {leading: false}.
    // To disable execution on the trailing edge, ditto.
    // =============================================================================
    var context; var args; var result
    var timeout = null; var previous = 0
    if (!options) {
      options = {}
    }
    function later () {
      previous = options.leading === false ? 0 : new Date()
      timeout = null
      result = func.apply(context, args)
      if (!timeout) {
        context = null
        args = null
      }
    };
    return function throttleFunc () {
      var now = new Date().getTime()
      if (!previous && options.leading === false) {
        previous = now
      }
      var remaining = wait - (now - previous)
      context = this
      args = arguments
      if (remaining <= 0 || remaining > wait) {
        clearTimeout(timeout)
        timeout = null
        previous = now
        result = func.apply(context, args)
        if (!timeout) {
          context = null
          args = null
        }
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining)
      }
      return result
    }
  }

  W.sg.debounce = function debounce (func, wait, immediate) {
    // =============================================================================
    // http://underscorejs.org/docs/underscore.html#section-83
    // Returns a function, that, as long as it continues to be invoked, will not be
    // triggered. The function will be called after it stops being called for
    // N milliseconds. If immediate is passed, trigger the function on the leading
    // edge, instead of the trailing.
    // =============================================================================
    var timeout; var args; var context; var timestamp; var result

    var later = function () {
      var last = new Date().getTime() - timestamp

      if (last < wait && last >= 0) {
        timeout = setTimeout(later, wait - last)
      } else {
        timeout = null
        if (!immediate) {
          result = func.apply(context, args)
          if (!timeout) {
            context = null
            args = null
          }
        }
      }
    }

    return function () {
      context = this
      args = arguments
      timestamp = new Date().getTime()

      var callNow = immediate && !timeout

      if (!timeout) {
        timeout = setTimeout(later, wait)
      }
      if (callNow) {
        result = func.apply(context, args)
        context = null
        args = null
      }

      return result
    }
  }

  W.sg.viewport = (function () {

    var $W = $(W); var $D = $(D); var prevStatus

    var viewport = {

      MOBILE: 320,

      PORTRAIT: 768,

      TABLET: 1024,

      DESKTOP: 1440,

      BREAKPOINTS: [320, 768, 1024, 1440],

      ORIENTATION_EVENT: 'onorientationchange' in W ? 'orientationchange' : 'resize',

      isMobile: function () {
        return this.computeStatus() === 'mobile'
      },

      isPortrait: function () {
        return this.computeStatus() === 'portrait'
      },

      isTablet: function () {
        return this.computeStatus() === 'tablet'
      },
      
      isDesktop: function () {
        return this.computeStatus() === 'desktop'
      },

      computeStatus: function () {
        var oComputedStyles; var sContent = 'mobile'
        if ('getComputedStyle' in W) {
          oComputedStyles = D.querySelector('body') ? W.getComputedStyle(D.querySelector('body'), ':before') : null
          sContent = oComputedStyles ? oComputedStyles.getPropertyValue('content') : 'mobile'
        }

        switch (true) {
          case sContent.indexOf('desktop') > -1 :
            this.status = 'desktop'
            break
          case sContent.indexOf('tablet') > -1 :
            this.status = 'tablet'
            break
          case sContent.indexOf('portrait') > -1 :
            this.status = 'portrait'
            break
          default :
            this.status = 'mobile'
            break
        }

        return this.status
      },

      computeWidth: function () {
        viewport.width = $W.width()
        return viewport.width
      },

      computeHeight: function () {
        viewport.height = $W.height()
        return viewport.height
      },

      compute: function () {
        return {
          status: this.computeStatus(),
          width: this.computeWidth(),
          height: this.computeHeight()
        }
      },
      isElementInViewport: function (el) {
        if (typeof jQuery === 'function' && el instanceof jQuery) {
          el = el[0]
        }

        var rect = el.getBoundingClientRect()
        var top = 0
        
        return (
          rect.top >= top &&
              rect.left >= 0 &&
              rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
              rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
        )
      },
      isVisible: function (el, callback) {
        return function () {
          var visible = viewport.isElementInViewport(el)
          if (visible) {
            if (typeof callback === 'function') {
              callback()
            }
          }
        }
      },
      init: function () {
        viewport.$meta = $('meta[name=viewport]')

        prevStatus = this.status

        _handleScroll = W.sg.throttle(_handleScroll, 300)
        _handleScrollEnd = W.sg.debounce(_handleScrollEnd, 300)
        _handleResize = W.sg.throttle(_handleResize, 150, { leading: false })
        _handleResizeEnd = W.sg.debounce(_handleResizeEnd, 300)

        $D.ready(function () {
          viewport.compute()
          _handleResizeEnd()
          _handleScrollEnd()

          $W
            .on(viewport.ORIENTATION_EVENT + '.sg:viewport', function () {
              _handleResize()
              _handleResizeEnd()
            })
            .on('scroll.sg:viewport', function () {
              _handleScroll()
              _handleScrollEnd()
            })
        })
      }
    }

    var _handleResize = function (oEvt) {
      viewport.compute()
      $D.trigger('sg:viewport.resize', {
        originalEvent: oEvt,
        context: viewport
      })
    }

    var _handleResizeEnd = function (oEvt) {
      viewport.compute()

      if (viewport.status !== prevStatus) {
        /* trigger a viewport changed event */
        $D.trigger('sg:viewport.change', {
          originalEvent: oEvt,
          context: viewport
        })
        prevStatus = viewport.status
      }

      $D.trigger('sg:viewport.resize-end', {
        originalEvent: oEvt,
        context: viewport
      })
    }

    var _handleScroll = function (oEvt) {
      viewport.compute()

      $D.trigger('sg:viewport.scroll', {
        originalEvent: oEvt,
        context: viewport,
        scrollTop: $W.scrollTop(),
        scrollLeft: $W.scrollLeft()
      })

    }

    var _handleScrollEnd = function (oEvt) {
      viewport.compute()

      $D.trigger('sg:viewport.scroll-end', {
        originalEvent: oEvt,
        context: viewport,
        scrollTop: $W.scrollTop(),
        scrollLeft: $W.scrollLeft()
      })
    }

    viewport.init()

    return viewport
  }())

})(window, document, jQuery)
